import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("s83_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("s83_token"); setUser(false); })
      .finally(() => setReady(true));
  }, []);

  const login = (data) => {
    localStorage.setItem("s83_token", data.access_token);
    setUser(data.user);
  };

  const logout = () => {
    localStorage.removeItem("s83_token");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, ready, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
